<cosmos-section
  [loading]="(_loading$ | async) === true"
>
  <div class="cosmos-clusters__table__wrapper">
    <cosmos-table
      [columns]="_columns"
      [dataSource]="_dataSource"
      [hasSearchbar]="true"
      (clickedRow)="openDetails($event)"
      class="cosmos-clusters__table"
    ></cosmos-table>
  </div>
</cosmos-section>
